import { render, staticRenderFns } from "./ConsumableFormModal.vue?vue&type=template&id=899fc6fc&"
import script from "./ConsumableFormModal.vue?vue&type=script&lang=js&"
export * from "./ConsumableFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports